(() => {
  const LIMIT = 30000; // €300 in centen

  const GIFTS = {
    burgundy: {
      id: 54632434958675,
      name: 'Burgundy Stripe'
    },
    brown: {
      id: 54632434434387,
      name: 'Brown Stripe'
    }
  };

  const GIFT_IDS = Object.values(GIFTS).map(gift => gift.id);

  let busy = false;

  const money = cents =>
    new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR'
    }).format(cents / 100);

  async function getCart() {
    const response = await fetch('/cart.js', {
      cache: 'no-store'
    });

    if (!response.ok) throw new Error('Winkelwagen ophalen mislukt');

    return response.json();
  }

  function qualifyingTotal(cart) {
    return cart.items.reduce((total, item) => {
      if (GIFT_IDS.includes(item.variant_id)) return total;

      return total + item.final_line_price;
    }, 0);
  }

  function renderGift(cart) {
    const containers = document.querySelectorAll('[data-aimee-gift]');
    const total = qualifyingTotal(cart);

    const giftItems = cart.items.filter(item =>
      GIFT_IDS.includes(item.variant_id) &&
      item.properties &&
      item.properties._aimee_gift === 'yes'
    );

    containers.forEach(container => {
      const content = container.querySelector(
        '.aimee-gift-drawer__content'
      );

      if (!content) return;

      if (total < LIMIT) {
        content.textContent =
          `Besteed nog ${money(LIMIT - total)} en ontvang een gratis Petit Foulard bij je bestelling.`;
        return;
      }

      if (giftItems.length) {
        content.textContent =
          'Je gratis Petit Foulard zit in je winkelwagen ✓';
        return;
      }

      content.innerHTML = `
        <p>Je ontvangt een gratis Petit Foulard. Kies jouw favoriete kleur!</p>
        <div class="aimee-gift-drawer__buttons">
          <button type="button"
            class="aimee-gift-drawer__button"
            data-aimee-gift-add="${GIFTS.burgundy.id}">
            Burgundy Stripe
          </button>
          <button type="button"
            class="aimee-gift-drawer__button"
            data-aimee-gift-add="${GIFTS.brown.id}">
            Brown Stripe
          </button>
        </div>
      `;
    });
  }

  async function updateGift(cart) {
    if (busy) return;

    const total = qualifyingTotal(cart);

    const gifts = cart.items.filter(item =>
      GIFT_IDS.includes(item.variant_id) &&
      item.properties &&
      item.properties._aimee_gift === 'yes'
    );

    if (total >= LIMIT || !gifts.length) return;

    busy = true;

    try {
      for (const gift of gifts) {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: gift.key,
            quantity: 0
          })
        });

        if (!response.ok) {
          throw new Error('Cadeau verwijderen mislukt');
        }
      }

      window.location.reload();
    } finally {
      busy = false;
    }
  }

  async function refreshGift() {
    if (busy) return;

    try {
      const cart = await getCart();
      renderGift(cart);
      await updateGift(cart);
    } catch (error) {
      console.error('Aímée cadeauactie:', error);
    }
  }

  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-aimee-gift-add]');

    if (!button || busy) return;

    event.preventDefault();

    busy = true;
    button.disabled = true;
    button.textContent = 'Toevoegen...';

    try {
      const cart = await getCart();

      if (qualifyingTotal(cart) < LIMIT) {
        throw new Error('Bestelbedrag is lager dan €300');
      }

      const variantId = Number(button.dataset.aimeeGiftAdd);

      if (!GIFT_IDS.includes(variantId)) return;

      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: {
              _aimee_gift: 'yes'
            }
          }]
        })
      });

      if (!response.ok) {
        throw new Error('Cadeau toevoegen mislukt');
      }

      window.location.reload();

    } catch (error) {
      console.error('Aímée cadeauactie:', error);
      alert('Het toevoegen van je cadeau is niet gelukt. Probeer het opnieuw.');
      busy = false;
      button.disabled = false;
      button.textContent =
        button.dataset.aimeeGiftAdd == GIFTS.burgundy.id
          ? 'Burgundy Stripe'
          : 'Brown Stripe';
    }
  });

  document.addEventListener('DOMContentLoaded', refreshGift);

  // Controleer opnieuw wanneer de winkelwagen verandert.
  document.addEventListener('cart:updated', refreshGift);

  // Controleer ook wanneer de cart drawer opnieuw wordt opgebouwd.
  const observer = new MutationObserver(() => {
    if (document.querySelector('[data-aimee-gift]')) {
      clearTimeout(window.aimeeGiftTimer);
      window.aimeeGiftTimer = setTimeout(refreshGift, 500);
    }
  });

  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.querySelector('.js-cart-drawer');

    if (drawer) {
      observer.observe(drawer, {
        childList: true,
        subtree: true
      });
    }
  });
})();